import axios, {AxiosResponse} from 'axios'
import {useIntl} from 'react-intl'
import React, {useEffect, useState, Fragment } from 'react';
import {useParams, useHistory} from 'react-router-dom'
import PublicationList from './PublicationsList'
import {UserModel} from '../../auth/models/UserModel'
import {UserCvModel} from '../../profile/models/UserCv'
import {RootState} from '../../../../setup'
import {shallowEqual, useSelector} from 'react-redux'
import {PublicationModel} from '../models/PublicationModel'
import {KTSVG} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {FormStepHorizontal} from '../../builderform/FormStepHorizontal'
import {FormBase} from '../../builderform/FormBase'
import GetTaxoTerms from '../../builderform/GetTaxoTerms'
import { Autocomplete } from '@mui/material'
import { TextField } from '@material-ui/core'
import {Collapse, Button} from 'react-bootstrap-v5'
import {useLang} from '../../../../_metronic/i18n/Metronici18n'

import {Modal} from 'react-bootstrap-v5'

import {PagerList} from '../../widgets/components/PagerList' 

const API_URL = process.env.REACT_APP_API_URL


const LIST_URL = `${API_URL}/list/publications?`
const DOWNLOAD_URL = `${API_URL}/download/publications?`
const MY_LIST_URL = `${API_URL}/list/publications/my-publications?`
//const FORM_URL = `${API_URL}/services/entity/form`
const headers = {
    "Content-Type" : "application/hal+json",
    "Accept" : "application/hal+json"
}
const headers_download = {
    "Content-Type" : "text/csv",
    "Accept" : "text/csv"
}

export type TPublicationList = PublicationModel[]

export function Publications(props : {mypub: boolean}){
    const intl = useIntl()
    const lang = useLang()
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const cv: UserCvModel = useSelector<RootState>(({auth}) => auth.cv, shallowEqual) as UserCvModel

    const [options, setOptions] = useState([])
    const [nidValue, setNidValue] = useState('')
    var alreadyLoadedIds: any = []
    var alreadyOptions: any = []

    const userId = user.role === 'administrator' ? '': user.id
    const researcherId = user.role === 'administrator' ? '': cv.id
    const initFilters = [
            {name : 'user', value: userId},
            {name : 'researcher', value: researcherId},
            {name : 'keyword', value: ''},
            {name : 'author', value: ''},
            {name : 'external', value: ''},
            {name : 'status', value: ''},
            {name : 'category', value: ''},
            {name : 'domain', value: ''},
            {name : 'faculty', value: ''},
            {name : 'date-start', value: ''},
            {name : 'date-end', value: ''}
        ]

    const [publications, setPublicationList] = useState<PublicationModel[]>([]);
    const [pager, setPager] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState<any>(0);
    const [total, setTotal] = useState(0)
    
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState(initFilters)
    const [openFilters, setOpenFilters] = useState(false)
    
    function fetchPublications(page: any) {
	    setLoading(true);
	    
        let buildGet = ''
        Object.entries(filters).forEach((fil : any)=>{
            if(fil[1].value !== ''){
                buildGet += fil[1].name+'='+fil[1].value+'&'
            }
        })
        const baseURL = props.mypub === true ? MY_LIST_URL : LIST_URL
        const full_url = baseURL + encodeURI(buildGet) + "&page=" + page
        axios.get(full_url, {headers})
            .then((response: AxiosResponse) => {
	             window.scrollTo({
			      top: 0,
			      left: 0,
			      behavior: 'smooth'
			    });
                setPublicationList( response.data.results );
                setPager( response.data.pager );
                setTotal(response.data.pager.count)
                setLoading(false);
            });
    }
    
    function downloadPublications(page: any) {
	    //setLoading(true);
	    
        let buildGet = ''
        Object.entries(filters).forEach((fil : any)=>{
            if(fil[1].value !== ''){
                buildGet += fil[1].name+'='+fil[1].value+'&'
            }
        })
        
        const full_url = DOWNLOAD_URL + encodeURI(buildGet)
        
        window.location.href = full_url
    }

    const FilteringPublications = (e : any) => {
        setLoading(true);
        const objIndex = filters.findIndex((obj => obj.name === e.target.name));
        filters[objIndex].value = e.target.value
        fetchPublications(0);
    };

    const DownloadPublications = (e : any) => {
        setLoading(true);
        const objIndex = filters.findIndex((obj => obj.name === e.target.name));
        filters[objIndex].value = e.target.value
        fetchPublications(0);
    };

    const reloadOptions = (event: any) => {

        const build_url = API_URL  + "/" + lang + "/autocomplete/node/co_author+researcher?_format=hal+json&filter=" + event.target.value

        axios.get(build_url, {headers})
            .then((response: AxiosResponse) => {

                //ON FUSIONNE AVEC LES OPTIONS DEJA CHARGE (POUR NE PAS PERDRE LES VALEURS INITIALES)
                response.data.forEach((value: any)=>{
                    if(alreadyLoadedIds.indexOf(value.value) === -1){
                        alreadyLoadedIds.push(value.value)
                        alreadyOptions.push(value)
                    }
                })

                //SET STATE OPTIONS
                setOptions(alreadyOptions)

                console.log(alreadyOptions)

            });

    }

    const setValue = (values: any) => {
        setLoading(true);
        if(values !== null) {
            const objIndex = filters.findIndex((obj => obj.name === "author"));
            filters[objIndex].value = values.value
            fetchPublications(0);
        }
        else{
            const objIndex = filters.findIndex((obj => obj.name === "author"));
            filters[objIndex].value = ''
            fetchPublications(0);
        }
    }

    useEffect(()=>{
        fetchPublications(0)
    }, [])

    var nbR;
    if (total === 0) {
        nbR = intl.formatMessage({id: 'EDHEC.LABEL.NO_RESULT'});
    }
    else if(total === 1){
        nbR = total +' '+ intl.formatMessage({id: 'EDHEC.LABEL.RESULT'});
    }
    else{
        nbR = total +' '+ intl.formatMessage({id: 'EDHEC.LABEL.RESULTS'});
    }
    return(
        <div>
            <Link to='/publications/add' className='btn btn-sm btn-secondary me-3 mb-5'>
                <KTSVG
                    path='/media/icons/duotune/arrows/arr075.svg'
                    className='svg-icon-1 svg-icon-primary'
                />
                {intl.formatMessage({id: 'EDHEC.LABEL.ADD_PUB'})}
            </Link>
            <div className={`card`}>
                <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bolder fs-3 mb-1'>{user.role === 'administrator' ? intl.formatMessage({id: 'EDHEC.LABEL.ALL_PUBLICATIONS'}): props.mypub ? intl.formatMessage({id: 'EDHEC.LABEL.MY_PUBLICATIONS'}): intl.formatMessage({id: 'EDHEC.LABEL.PUBLICATIONS'})}</span>
                        <span className='text-muted mt-1 fw-bold fs-7'>{nbR}</span>
                    </h3>
                    <div className='card-toolbar'>
                        { (user.role === 'administrator' || user.role === 'consultation' || user.role === 'manager' || user.role === 'assistant'  || user.role === 'gestionnaire'  )?(
                            <Button className="btn btn-secondary btn-sm me-3" onClick={downloadPublications}>
                                <KTSVG path='/media/icons/duotune/files/fil009.svg' className='svg-icon-3' />
                                {intl.formatMessage({id: 'EDHEC.LABEL.EXTRACT'})}
                            </Button>
                        ):(
                            <></>
                        )}
                        <Button className="me-3" onClick={()=> setOpenFilters(!openFilters)} aria-expanded={openFilters} aria-controls="filtersCollapse">
                            <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-3' />
                            {intl.formatMessage({id: 'EDHEC.LABEL.FILTERS'})}
                        </Button>

                         
                        <form className='form'>
                            <label className='form-check form-check-custom form-check-solid align-items-start'>
                                <input
                                    name='keyword'
                                    type='text'
                                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                    placeholder={intl.formatMessage({id: 'EDHEC.LABEL.KEYWORD'})+'...'}
                                    onChange={FilteringPublications}
                                />
                            </label>
                        </form>
                    </div>
                </div>
                <Collapse in={openFilters}>
                    <div id='filtersCollapse'>
                        <div className='card-body pt-5'>
                            <form className='border form py-2 d-flex row justify-content-between'>
                                <div className='d-flex column py-2'>
                                    <div className='px-2 d-flex align-items-center'>
                                        <label className='label w-25' >{intl.formatMessage({id: 'EDHEC.LABEL.FROM'})} :</label>
                                        <input
                                            name='date-start'
                                            type='date'
                                            className='px-2 form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                            onChange={FilteringPublications}
                                        />
                                    </div>
                                    <div className='px-2 d-flex align-items-center'>
                                        <label className='label w-25' >{intl.formatMessage({id: 'EDHEC.LABEL.TO'})} :</label>
                                        <input
                                            name='date-end'
                                            type='date'
                                            className='px-2 form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                            onChange={FilteringPublications}
                                        />
                                    </div>
                                    <div className='w-100 px-2 d-flex align-items-center justify-content-end'>
                                        <label className='label w-auto me-4' >{intl.formatMessage({id: 'EDHEC.LABEL.AUTHOR'})} :</label>
                                        <Autocomplete
                                            disablePortal
                                            id='author'
                                            className="w-75 form-control form-control-lg form-control-solid"
                                            options={options}
                                            sx={{  }}
                                            renderInput={(params) =>
                                                <TextField {...params} label=""
                                                           className="w-100"
                                                           onKeyDown={(newValue) => {
                                                               reloadOptions(newValue);
                                                           }} />}
                                            onChange={(event, newValue) => {
                                                setValue(newValue);
                                            }}

                                        />
                                    </div>
                                </div>
                                <div className='d-flex column py-2'>
                                    <div className='px-2'>
                                        <select
                                            name='category'
                                            className='px-2 form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                            onChange={FilteringPublications}
                                        >
                                            <GetTaxoTerms name='publication' title='Category'/>
                                        </select>
                                    </div>
                                    <div className='px-2'>
                                        <select
                                            name='faculty'
                                            className='px-2 form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                            onChange={FilteringPublications}
                                        >
                                            <GetTaxoTerms name='faculty' title='faculty'/>
                                        </select>
                                    </div>
                                </div>
                                <div className='d-flex column py-2'>
                                    <div className='px-2'>
                                        <select
                                            name='domain'
                                            multiple
                                            className='px-2 form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                            onChange={FilteringPublications}
                                        >
                                            <GetTaxoTerms name='domain' title='domains'/>
                                        </select>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Collapse>
                <div className='card-body py-3'>
                    <div className='table-responsive'>
                        <table className='table align-middle gs-0 gy-4'>
                            <thead>
                            <tr className='fw-bolder text-muted bg-light'>
                                <th className='ps-4 rounded-start'>{intl.formatMessage({id: 'EDHEC.LABEL.TITLE'})}</th>
                                <th>{intl.formatMessage({id: 'EDHEC.LABEL.CATEGORY'})}</th>
                                <th>{intl.formatMessage({id: 'EDHEC.LABEL.REVIEW'})}</th>
                                <th>{intl.formatMessage({id: 'EDHEC.LABEL.PUBLISHED'})}</th>
                                <th>{intl.formatMessage({id: 'EDHEC.LABEL.CHANGED'})}</th>
                                <th className='text-end rounded-end'></th>
                            </tr>
                            </thead>
                            <tbody>
                            { loading ?(
                                <tr><td>
                                    <div className='d-flex align-items-center justify-content-center m-5'>
                                        loading...
                                    </div>
                                </td></tr>
                                ):(
                                    <PublicationList items={publications}/>
                                )}
                            </tbody>
                        </table>
                        
                        <>
                        	<PagerList pager={pager} current_page={currentPage} setPage={setCurrentPage} reloadList={fetchPublications}/>
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function FormPublication(){

    const intl = useIntl()
    const history = useHistory();
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const [formStructure, setFormStructure] = useState<any>([]);
    const [formApprobationStructure, setFormApprobationStructure] = useState<any>([]);
    const [formAuthorExtStructure, setFormAuthorExtStructure] = useState<any>([]);
    const { nid } = useParams<{ nid: string}>();
    
    
	const lang = useLang()
	const FORM_URL = API_URL + "/" + lang + "/services/entity/form"

    const build_url = typeof nid != "undefined" ? FORM_URL+ '?_format=hal+json&type=publications&id='+ nid : FORM_URL+ '?_format=hal+json&type=publications';

	  const [showModalAuthor, setShowModalAuthor] = useState(false);
	
	  const handleClose = () => setShowModalAuthor(false);
	  const handleShow = () => setShowModalAuthor(true);
	  
    useEffect(() => {
        // Use [] as second argument in useEffect for not rendering each time
        axios.get(build_url, {headers})
            .then((response: AxiosResponse) => {
                //STOCK GLOBAL
                window.FormSettings.publication = response.data.settings;
	            window.FormSettings.publication.nosubmit = response.data.nosubmit
	            console.log('ici',Object.keys(response.data.structure), window.FormSettings.publication)
                setFormStructure( Object.keys(response.data.structure) );
            });
        
        /*
        // !!!!!! DESACTIVATION MODERATION 08/2023 !!!!!!
        
        // APPROBATION FORM
        if(typeof nid != "undefined"){
	        axios.get(build_url + "&display_mode=approbation_form", {headers})
	            .then((response: AxiosResponse) => {
	                //STOCK GLOBAL
	                window.FormSettings.publication_approbation = response.data.settings
	                window.FormSettings.publication_approbation.nosubmit = response.data.nosubmit
	                setFormApprobationStructure( Object.keys(response.data.structure) )
	            });
        }
        
        */
        
        // AUTHOR EXTERNE FORM FORM
        axios.get(FORM_URL+ '?_format=hal+json&type=co_author', {headers})
            .then((response: AxiosResponse) => {
                //STOCK GLOBAL
                window.FormSettings.co_author = response.data.settings
                setFormAuthorExtStructure( Object.keys(response.data.structure) )
            });
            
    }, [build_url, nid]);
    
    return(
        <div>
            <a onClick={history.goBack} className='btn btn-sm btn-secondary me-3'>
                <KTSVG
                    path='/media/icons/duotune/arrows/arr063.svg'
                    className='svg-icon-1 svg-icon-primary'
                />
                {intl.formatMessage({id: 'EDHEC.RETURN'})}
            </a>
            {typeof formStructure != "undefined" && formStructure.length > 0 ? (
                <FormStepHorizontal
                    items={formStructure[0]}
                    user={user.id}
                    nid={nid}
                    type='publications'
                    destination='/publications'
                    form_name='publication'
                    state_modal={setShowModalAuthor}
                />
            ):(
	            <></>
            )}
            
            {typeof formApprobationStructure != "undefined" && formApprobationStructure.length > 0 ? (
                <FormBase
                    items={formApprobationStructure[0]}
                    user={user.id}
                    nid={nid}
                    type='publications'
                    destination='/publications'
                    form_name='publication_approbation'
                    title_form='Moderation'
                />
            ):(
	            <></>
            )}
            
            {typeof formAuthorExtStructure != "undefined" && formAuthorExtStructure.length > 0 ? (
	            <div>
		
		            <Modal show={showModalAuthor} backdrop="static" onHide={handleClose} >
					  <Modal.Header>
					    <Modal.Title>{"Add New External Authors"}</Modal.Title>
                          <button className="btn-close" onClick={handleClose}></button>
					  </Modal.Header>
					
					  <Modal.Body>
					    
			            <div id="add_new_co_author">
			                <FormBase
			                    items={formAuthorExtStructure[0]}
			                    user={user.id}
			                    nid=""
			                    type='co_author'
			                    destination='#'
			                    form_name='co_author' 
			                    title_form=''
								state_modal={setShowModalAuthor}
			                />
		                </div>
		                
					  </Modal.Body>
					</Modal>
				</div>

            ):(
	            <></>
            )}
            
        </div>
    );
}

export function Summary(props: {manager?: boolean, setTotal?: any, setTotalPub?: any}){

    const [sum, setSum] = useState([]);
    const [loading, setLoading] = useState(true)
    const build_url = props.manager ? API_URL+'/services/publications/summary?_format=hal+json&manager=true' : API_URL+'/services/publications/summary?_format=hal+json'
    useEffect(() => {
        axios.get(build_url, {headers})
            .then((response: AxiosResponse) => {
                const total = Object.values(response.data).shift()
                delete response.data.total
                props.setTotal(total)
                const totalpub = Object.values(response.data).shift()
                delete response.data.totalpub
                if(props.setTotalPub){
                    props.setTotalPub(totalpub)
                }
                setSum( response.data)
                setLoading(false)
            });
    }, [build_url, props]);
    return(
        <div className='card mb-5 mb-xl-10 d-flex flex-row flex-wrap'>
            {loading === false ?
                Object.entries(sum).map((val: any, key: any)=>(
                    <div key={key} className='w-50 pe-20 d-flex justify-content-between mb-5'>
                        <label className='text-muted fw-bold'>{val[0]}</label>
                        <div className='mx-10'><span className='fw-bold fs-6'>{val[1]}</span></div>
                    </div>
                ))
            :(
                    <div>Loading...</div>
                )}
        </div>
    )
}

export function PendingPubli(){

    const intl = useIntl()
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const [pending, setPending] = useState([]);
    const build_url = API_URL+'/services/publications/pending?_format=hal+json'
    useEffect(() => {
        axios.get(build_url, {headers})
            .then((response: AxiosResponse) => {
                setPending( response.data );
            });
    }, [build_url]);
    if(user.role === 'manager'){
        return(
            <div className='card mb-5 mb-xl-10 d-flex flex-column flex-wrap'>
                {pending.map((val: any, key: any)=>(
                    <div key={key} className='d-flex justify-content-between align-items-baseline'>
                        <div className='d-flex flex-column'>
                            <div className='fw-bold fs-6'>{val.name} {intl.formatMessage({id: 'EDHEC.LABEL.SET_A'})} {val.type} ”{val.title}” {intl.formatMessage({id: 'EDHEC.LABEL.FOR_APPROVAL'})}</div>
                            <div className='text-muted fw-bold'>{val.lastupdate}</div>
                        </div>
                        <Link to={'/publications/edit/'+val.nid} className='btn btn-bg-light btn-active-color-primary'>
                            {intl.formatMessage({id: 'EDHEC.BUTTON.REVIEW'})}
                            <KTSVG path='/media/icons/duotune/arrows/arr001.svg' className='px-2 svg-icon-2' />
                        </Link>
                    </div>
                ))}
            </div>
        )
    }
    return(
        <div>
            <div className='text-gray-800 text-hover-primary fs-2 fw-bolder mb-5'>
                {intl.formatMessage({id: 'EDHEC.LABEL.LAST_ACTIVITIES'})}
            </div>
            {pending.map((val: any, key: any)=>(
                <div className='card mb-5'>
                    <div className='card-body d-flex flex-column flex-wrap'>
                        <div key={key} className='d-flex justify-content-between align-items-baseline'>
                            <div className='d-flex flex-column'>
                                <div className='fw-bold fs-6'>{intl.formatMessage({id: 'EDHEC.LABEL.YOUR'})} {val.type} ”{val.title}” {intl.formatMessage({id: 'EDHEC.LABEL.APPROVAL'})}</div>
                                <div className='text-muted fw-bold'>{val.lastupdate}</div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
